import React from 'react'
import { array } from 'common/helpers'

import Cell from '../Cell/Cell'


const FillCell = ({ children, columns, gutter, index }) => {
  const sizes = array.range(1, columns)
  const size  = sizes.find((cellSize) => (
    (index + cellSize) / columns % 1 === 0
  ))

  return (
    <Cell columns={columns} size={size} gutter={gutter}>
      {Boolean(children) && React.cloneElement(children, { size })}
    </Cell>
  )
}


export default FillCell
